import { getLocale, consoleEvents } from '@pb/utils'

import { ACCOUNT_ROUTES } from 'App/constants'
import { SELECTED_INVOICE_PARAM } from 'features/account/hm-pay/constants'

import { getFullTouchpointUrl } from './touchpointUrl'

const runKlarnaOperation = (token: string, invoiceId?: string): Promise<unknown> => {
  // Klarna wants format en-GB and not en_gb
  const splitLocale = getLocale().split('_')
  const klarnaLocale = `${splitLocale[0]}-${splitLocale[1].toUpperCase()}`

  return new Promise((resolve, reject) => {
    Klarna.PostPurchaseExperience.renderOperation(
      {
        operation_token: token,
        locale: klarnaLocale,
        // redirect_uri for Klarna to navigate back to when the user has been
        // navigated away to an external app or website to complete the payment
        ...(invoiceId && {
          redirect_uri: `${getFullTouchpointUrl()}${
            ACCOUNT_ROUTES.HMPay.path
          }?${SELECTED_INVOICE_PARAM}=${invoiceId}`,
        }),
      },
      (error, data) => {
        if (error) {
          consoleEvents.error('Klarna Error', error)
          reject(error)
        }
        resolve(data)
      },
    )
  })
}

export default runKlarnaOperation
